import { render, staticRenderFns } from "./surveillanceUserInfo.vue?vue&type=template&id=2a738d3d&scoped=true"
import script from "./surveillanceUserInfo.vue?vue&type=script&lang=js"
export * from "./surveillanceUserInfo.vue?vue&type=script&lang=js"
import style0 from "./surveillanceUserInfo.vue?vue&type=style&index=0&id=2a738d3d&prod&lang=less"
import style1 from "./surveillanceUserInfo.vue?vue&type=style&index=1&id=2a738d3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a738d3d",
  null
  
)

export default component.exports